import { PlainBtn } from '@/buttons';
import { CLink } from '@/CLink';
import { Dialog, DialogClose, DialogContent, DialogOpen } from '@/DialogPrimitive';
import { ReactComponent as ChevronIcon } from '@a/icons/chevron.svg';
import { css } from '@emotion/react';
import useLocationData from '@s/hooks/useLocationData';
import useRouteChange from '@s/hooks/useRouteChange';
import useWindowSize from '@s/hooks/useWindowSize';
import { Fragment, useEffect, useState } from 'react';
import { NavLinksTypes } from './NavLinks';
import { navBtnStyles, subNavLinkStyles } from './NavLinkStyles';
import { flexStart } from './styles/classes';

const overlayStyles = css`
    display: none;
`;

const contentStyles = css`
    position: fixed;
    top: 85px;
    left: 0;
    right: 0;
    bottom: 0;

    > button:first-of-type {
        margin-left: auto;
        margin-right: auto;
        max-width: max-content;
        display: flex;
    }

    > nav {
        ${flexStart};
        flex-direction: column;
        align-items: center;
        height: calc(100% - 32px);
        overflow-y: auto;
    }

    @media (min-height: 720px) {
        padding: 64px;
        > div {
            margin-bottom: 80px;
        }
    }
`;

type SubNavProps = {
    text: string;
    links: NavLinksTypes;
    setSubDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const MobSubNav = ({ text, links, setSubDialogOpen }: SubNavProps) => {
    const [open, setOpen] = useState(false);

    const { width } = useWindowSize();

    useRouteChange(setOpen);

    const { category } = useLocationData();

    useEffect(() => {
        setSubDialogOpen(open);
    }, [open, setSubDialogOpen]);

    return width < 1360 ? (
        <Dialog open={open} onOpenChange={setOpen} modal={false}>
            <DialogOpen>
                <PlainBtn
                    aria-label={`open ${text} menu`}
                    css={navBtnStyles}
                    className={category === text ? 'current-nav-category' : ''}
                >
                    {text} <ChevronIcon />
                </PlainBtn>
            </DialogOpen>

            <DialogContent
                contentStyles={contentStyles}
                overlayStyles={overlayStyles}
                title={`${text} navigation menu`}
            >
                <DialogClose>
                    <PlainBtn
                        data-mobile-expanded="true"
                        css={navBtnStyles}
                        className={category === text ? 'current-nav-category' : ''}
                    >
                        {text} <ChevronIcon />
                    </PlainBtn>
                </DialogClose>
                <nav>
                    {links.map((data, i) => (
                        <CLink to={data.link} css={subNavLinkStyles} key={i}>
                            {data.text}
                        </CLink>
                    ))}
                </nav>
            </DialogContent>
        </Dialog>
    ) : (
        <Fragment />
    );
};
